import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { PageLayout } from '@hero/components/layouts';

const Container = styled.div`
  left: 80px;
  position: fixed;
  right: 0;
  top: 300px;
  transition: all 0.3s ease;
  width: 80%;
  z-index: 1000;

  ${({ $isVisible }) =>
    $isVisible &&
    `
    transform: translateY(0);
    transition: all 0.3s ease;
    left: 200px;
    top: 20px;
    width: 60%;
  `}
`;

function StickyHeader({ children, scrollThreshold = 100 }) {
  const headerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const observerRef = useRef(null);
  const scrollContainerNode = document.querySelector(`${PageLayout.S.PageLayoutContent}`);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = scrollContainerNode.scrollTop;
      setIsSticky(scrollPosition > scrollThreshold);
    };

    // Set up the intersection observer
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsSticky(false);
        }
      });
    }, options);

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    // Add scroll event listener
    scrollContainerNode.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      scrollContainerNode.removeEventListener('scroll', handleScroll);
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [scrollThreshold, observerRef]);

  return (
    <>
      <div
        ref={observerRef}
        style={{
          height: '1px',
          width: '100%',
          position: 'absolute',
          top: '100px'
        }}
      />
      <Container ref={headerRef} $isVisible={isSticky}>
        {children}
      </Container>
    </>
  );
}

StickyHeader.propTypes = {
  children: PropTypes.node.isRequired,
  scrollThreshold: PropTypes.number
};

export { StickyHeader };
